<template>
  <transition name="negotiation-drawer">
    <div v-if="show" class="negotiation-drawer" @click.self="close">
      <aside
        class="negotiation-drawer__panel"
        role="dialog"
        aria-modal="true"
        :aria-label="$t('OPPORTUNITY_DETAILS.NEGOTIATION_FORM.TITLE')"
      >
        <opportunity-panel-header @close="close">
          {{ $t('OPPORTUNITY_DETAILS.NEGOTIATION_FORM.TITLE') }}
        </opportunity-panel-header>
        <opportunity-negotiation-form
          :opportunity="opportunity"
          :is-locked="isLocked"
          :pending-question-ids="pendingQuestionIds"
          :target-stage="targetStage"
          @saved="$emit('saved', $event)"
        />
      </aside>
    </div>
  </transition>
</template>

<script>
import OpportunityPanelHeader from '../OpportunityPanelHeader.vue';
import OpportunityNegotiationForm from './OpportunityNegotiationForm.vue';

export default {
  name: 'OpportunityNegotiationDrawer',
  components: {
    OpportunityNegotiationForm,
    OpportunityPanelHeader,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    opportunity: {
      type: Object,
      required: true,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    pendingQuestionIds: {
      type: Array,
      default: () => [],
    },
    targetStage: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown, true);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown, true);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKeydown(event) {
      if (this.show && event.code === 'Escape') {
        event.stopPropagation();
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.negotiation-drawer {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: flex-end;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9995;
}

.negotiation-drawer__panel {
  background: var(--white);
  box-shadow: var(--shadow-large);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  width: 45rem;
}

.negotiation-drawer-enter-active,
.negotiation-drawer-leave-active {
  transition: background-color 0.2s ease;

  .negotiation-drawer__panel {
    transition: transform 0.2s ease;
  }
}

.negotiation-drawer-enter,
.negotiation-drawer-leave-to {
  background-color: transparent;

  .negotiation-drawer__panel {
    transform: translateX(100%);
  }
}
</style>
